import React, { Component, createRef } from 'react';

// Server renders scale the original to fit these boxes (upscaling included)
const DESKTOP_BOX = [1920, 1440];
const MOBILE_BOX = [800, 600];

function fitWidth(image, [maxWidth, maxHeight]) {
  const width = Number(image.width);
  const height = Number(image.height);
  return Math.round(width * Math.min(maxWidth / width, maxHeight / height));
}

export function imageSrcSet(image) {
  return `${image.urlMobile} ${fitWidth(image, MOBILE_BOX)}w, ${image.urlDesktop} ${fitWidth(image, DESKTOP_BOX)}w`;
}

export class Image extends Component {
  state = { loaded: false };
  imgRef = createRef();

  componentDidMount() {
    // cached images may already be complete before onLoad is attached
    const img = this.imgRef.current;
    if (img && img.complete && img.naturalWidth > 0) {
      this.setState({ loaded: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.image.urlDesktop !== this.props.image.urlDesktop) {
      this.setState({ loaded: false });
    }
  }

  handleLoad = () => {
    this.setState({ loaded: true });
  };

  render() {
    
    const {image,style,className,sizes,loading} = this.props;
    const {loaded} = this.state;

    return (
      <img 
        ref={this.imgRef}
        loading={loading || "lazy"}
        src={image.urlDesktop} 
        srcSet={imageSrcSet(image)}
        sizes={sizes || "100vw"}
        alt="" 
        className={"d-block image-fade "+(loaded ? "is-loaded " : "")+(className || "")} 
        style={style} 
        width={image.width}
        height={image.height}
        onLoad={this.handleLoad}
        />
    );
  }
}
